import { Fragment } from 'react';
import { OptionListTypes } from './types';

import styles from './autocomplete-with-titles.module.css';

export default function OptionList({
  list,
  value = '',
  onSelectChange,
}: OptionListTypes) {
  return (
    <ul className={styles.autocompleteList}>
      {list?.length ? (
        list.map((item) => (
          <Fragment key={item.title}>
            <li className={styles.autocompleteListItemTitle}>{item.title}</li>
            {item.list.map((listItem) => (
              <li key={listItem.value}>
                <button
                  type="button"
                  className={`${styles.autocompleteListItemValue} ${
                    value === listItem.value
                      ? styles.autocompleteListItemValueActive
                      : ''
                  }`}
                  tabIndex={-1}
                  onClick={() =>
                    onSelectChange({
                      target: {
                        name: listItem.name,
                        value: listItem.value,
                      },
                    })
                  }
                >
                  {listItem.highlight || listItem.name}
                </button>
              </li>
            ))}
          </Fragment>
        ))
      ) : (
        <li className={styles.emptyListItem}>Not Found</li>
      )}
    </ul>
  );
}
